var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("header-kravicka", {
        attrs: { profil: _vm.profil },
        on: { updateProfil: _vm.emitUpdateProfil }
      }),
      _vm._v(" "),
      _c("main", [
        _c("div", { staticClass: "container" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "row align-items-center mb-5" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-md-12 col-xl-6 text-center text-xl-left mb-3 mb-xl-0"
              },
              [
                _c("span", { staticClass: "difficulty --label" }, [
                  _vm._v("Obtiažnosť hry")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "o-settingsGrid" },
                  [
                    _vm._l(_vm.pexesoObtiaznosti, function(obtiaznost) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "m-settingsGrid__item",
                            class: _vm.isSelectedObtiaznost(obtiaznost),
                            on: {
                              click: function($event) {
                                return _vm.selectObtiaznost(obtiaznost.id)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "a-settingsGrid__image" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "settingsGrid__value" },
                                  [_vm._v(_vm._s(obtiaznost.id))]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "a-settingsGrid__description" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "settingsGrid__name" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        obtiaznost.pexeso_obtiaznost_nadpis
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "settingsGrid__about" },
                                  [
                                    _vm._v(
                                      _vm._s(obtiaznost.pexeso_obtiaznost_popis)
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    })
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-12 col-xl-6 text-center text-xl-left" },
              [
                _c("span", { staticClass: "difficulty --label" }, [
                  _vm._v("Motív kartičiek")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "o-settingsGrid" },
                  [
                    _vm._l(_vm.pexesoMotivy, function(motiv) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "m-settingsGrid__item",
                            class: _vm.isSelectedMotiv(motiv),
                            on: {
                              click: function($event) {
                                return _vm.selectMotiv(motiv.id)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "a-settingsGrid__image" },
                              [
                                _c("img", {
                                  staticClass: "img-fluid",
                                  attrs: {
                                    src: motiv.pexeso_motiv_img,
                                    alt: ""
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "a-settingsGrid__description" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "settingsGrid__name" },
                                  [_vm._v(_vm._s(motiv.pexeso_motiv_nadpis))]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    })
                  ],
                  2
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row justify-content-center" }, [
            _c(
              "div",
              { staticClass: "col-md-12 text-center mb-5 mb-md-0" },
              [
                _vm.setMotiv && _vm.setObtiaznost
                  ? _c(
                      "div",
                      { staticClass: "buttonsWrap" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "btn --primary --large --startGame",
                            attrs: {
                              to: {
                                name: "pexeso-game",
                                params: {
                                  kravicka_id: _vm.$route.params.kravicka_id,
                                  obtiaznost_id: _vm.selectedObtiaznost,
                                  motiv_id: _vm.selectedMotiv
                                }
                              }
                            }
                          },
                          [
                            _c("span", { staticClass: "icon" }),
                            _vm._v("Spustiť hru\n                        ")
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "endGame d-lg-none d-xl-inline-block",
                    attrs: {
                      to: {
                        name: "kravicka",
                        params: { kravicka_id: _vm.$route.params.kravicka_id }
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                        Ukončiť hru a vrátiť sa ku kravičke"
                    ),
                    _c("span", { staticClass: "icon" })
                  ]
                )
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pexesoFooter --right d-none d-md-block" },
        [
          _c(
            "router-link",
            {
              staticClass: "btn --secondary --trophy",
              attrs: {
                to: {
                  name: "pexeso-leaders",
                  params: { kravicka_id: _vm.$route.params.kravicka_id }
                }
              }
            },
            [
              _c("span", { staticClass: "icon" }),
              _vm._v("Tabuľka najlepších\n        ")
            ]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "btn --primary closeGame",
              attrs: {
                to: {
                  name: "kravicka",
                  params: { kravicka_id: _vm.$route.params.kravicka_id }
                }
              }
            },
            [_c("span", { staticClass: "icon" })]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-content-center" }, [
      _c("div", { staticClass: "col-md-12 col-lg-8" }, [
        _c("h1", { staticClass: "text-center" }, [
          _vm._v("Nastav si svoje Pexeso")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "text-center pexesoDescription" }, [
          _vm._v(
            "Hmmm... Tak čo to bude? Radšej len level Pohodička, alebo si trúfaš hneď na Fúúúúha? Vyber si obtiažnosť a motív kartičiek a zábava môže začať."
          )
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }